import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const SPALLA_SCRIPT_URL = 'https://beyond.spalla.io/player/js/spalla.player.js'

const loadSpallaScript = (() => {
  let scriptLoaded = false

  return () => {
    return new Promise((resolve, reject) => {
      if (scriptLoaded || window.Spalla) {
        resolve()
        return
      }

      const script = document.createElement('script')
      script.src = SPALLA_SCRIPT_URL
      script.async = true
      script.onload = () => {
        scriptLoaded = true
        resolve()
      }
      script.onerror = reject
      document.body.appendChild(script)
    })
  }
})()

const Player = ({ id, initialTime, duration }) => {
  const playerRef = useRef(null)
  const time = Math.floor((initialTime / 100) * (duration ?? 0))
  const containerId = `spalla-player-${id}`
  useEffect(() => {
    if (!id) return

    loadSpallaScript().then(() => {
      const el = playerRef.current
      if (!el) return

      if (!document.getElementById(containerId)) {
        const playerDiv = document.createElement('div')
        playerDiv.id = containerId
        el.appendChild(playerDiv)
      }

      try {
        const player = new window.SpallaPlayer(containerId, {
          videoId: id,
          width: '100%',
          height: '100%',
          autoplay: false,
          bar: true,
          muted: false,
          subtitlePosition: 'inner',
          subtitleLanguage: null,
          resume: false,
          info: false,
          enableLikes: true,
          enableCc: true,
          t: time,
          playbackSpeeds: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.25, 3, 4],
          controls: [
            'play',
            'pause',
            'time',
            'live',
            'seekbar',
            'volume',
            'quality',
            'speed',
            'subtitles',
            'fullscreen',
            'forward',
            'backward',
            'settings',
            'cast',
          ],
        })
        player.on('ready', () => {
        })

        player.on('*', (e) => {
        })
      } catch (error) {
        console.error(error)
      }
    })
  }, [containerId, id, initialTime, time])

  return (
    <Wrapper>
      <WrapperInner>
        <PlayerWrapper
          ref={playerRef}
          id={containerId}
          className='spalla-player'
        />
      </WrapperInner>
    </Wrapper>
  )
}

const WrapperInner = styled.div`
  position: relative;
  padding-top: 56.25%; 
`

Player.propTypes = {
  id: PropTypes.string.isRequired,
  initialTime: PropTypes.number,
  duration: PropTypes.number,
}

const Wrapper = styled.div`
  position: relative;
  background: #000;
  width: 100%;
  border-radius: 8px;
`

const PlayerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export { Player }
